import { Spin } from 'antd';
import './style.css';

export default function Loader() {
  return (
    <div className='loading-container flex items-center justify-center'>
      <Spin style={{ width: '50px', height: '50px' }} />
    </div>
  );
}
